<template>
  <button class="btn btn-outline-primary float-end btn-sm" id="test" @click="buttonClick">{{ title }}</button>
</template>

<script>
export default {
  props: ['title', 'extra'],
  created () {
    /*
    EI TEA KAS VÕI MIS SEE TEEB SIIN
    const myDropdown = document.getElementById('test')
    myDropdown.addEventListener('show.bs.dropdown', event => {
      console.log(event)
    })
     */
  },
  methods: {
    buttonClick () {
      console.log('doAction', this.extra)
      this.$socket.emit('doAction', this.extra)
    }
  }
}
</script>
